import { render, staticRenderFns } from "./TheMoviesColumn.vue?vue&type=template&id=4da9f33e&scoped=true&"
import script from "./TheMoviesColumn.vue?vue&type=script&lang=coffee&"
export * from "./TheMoviesColumn.vue?vue&type=script&lang=coffee&"
import style0 from "./TheMoviesColumn.vue?vue&type=style&index=0&id=4da9f33e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9f33e",
  null
  
)

export default component.exports